// src/lib/api/communication/messages.js
import { supabase } from '../../supabase'
import { getValidatedCompanyId } from '../shared/helpers'
import { withErrorHandling, createSuccessResponse } from '../shared/errors'
import { logger } from '../../logger'

/**
 * Get messages
 * Migrated from supabaseApi.js lines 2329-2349
 * @param {string} [providedCompanyId] - Optional company ID (avoids internal lookup)
 */
const _getMessages = async (providedCompanyId = null) => {
  logger.communication('getMessages called')
  
  const companyId = providedCompanyId || await getValidatedCompanyId()
  if (!companyId) {
    logger.communication('No company ID found')
    return createSuccessResponse([])
  }

  const { data, error } = await supabase
    .from('messages')
    .select(`
      id,
      company_id,
      client_id,
      recipient,
      subject,
      body,
      type,
      status,
      from_name,
      from_email,
      to_name,
      to_email,
      sent_by,
      sent_at,
      created_at
    `)
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
    
  if (error) {
    logger.error('[communication] Error fetching messages:', error)
    throw error
  }

  logger.communication('getMessages success, found', data?.length || 0, 'messages')
  return createSuccessResponse(data || [])
}

// Export function with error handling
export const getMessages = withErrorHandling(_getMessages, 'get messages', 'messages')